import React from 'react';
import { Container, FormErrorMessage } from '@groupelacentrale/contact-storybook';
import { IconAutoviza, IconPencil, IconShield } from '@groupelacentrale/contact-storybook/lib/icons';
import { TermsOfService } from 'components';
import './PublicationOption.scss';

interface Props {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void | undefined;
  onKeyPressCheck: (e: React.KeyboardEvent) => void | undefined;
  name: string;
  error?: string;
}

export const PublicationOptionInfos: React.FC<Props> = ({ onKeyPressCheck, ...props }) => {
  return (
    <>
      <Container className="publication-option-infos" shadowed backgroundColor="bgWhite">
        <div className="infos">
          <div>
            <IconPencil />
            <span>
              <strong>Modifications gratuites</strong>&nbsp;de l&apos;annonce
            </span>
          </div>
          <div>
            <IconShield />
            <span>
              <strong>Protection Sécuritel</strong>&nbsp;de vos coordonnées
            </span>
          </div>
          <div>
            <IconAutoviza />
            <span>
              <strong>Rapport d&apos;historique</strong>&nbsp;Autoviza
            </span>
          </div>
        </div>
        <div className="checkbox-inside mobile-only" tabIndex={0} data-option="cgu" onKeyPress={onKeyPressCheck}>
          <TermsOfService {...props} hasError={props.error !== undefined} />
          {props.error !== undefined && <FormErrorMessage name={props.name} message={props.error} />}
        </div>
      </Container>
      <div className="checkbox-outside mobile-hidden" tabIndex={0} data-option="cgu" onKeyPress={onKeyPressCheck}>
        <TermsOfService {...props} hasError={props.error !== undefined} />
        {props.error !== undefined && <FormErrorMessage name={props.name} message={props.error} />}
      </div>
    </>
  );
};
